import dayjs from "dayjs";

export const CustomDateCell = ({ params }: any) => {
  return (
    <>{`${dayjs(params.row.from).format("DD")} ${dayjs(params.row.from).format(
      "MMM"
    )}, ${dayjs(params.row.from).format("h:mm A")}`}</>
  );
};
